<form (ngSubmit)="submitForm()" [formGroup]="quoteForm">
  <!--    Project Details Part-->
  <h3 class="heading">
    {{ 'form.quoteForm.projectDetails' | transloco }}
  </h3>

  <div class="label-content project-details">
    {{ 'form.quoteForm.estimatedRentalPeriod' | transloco }}
  </div>
  <div class="estimated-rental-period">
    <boels-quantity
      [value]="quoteForm.get('estimatedRentalPeriod')!.value"
      (quantityChanged)="
        quoteForm.patchValue({ estimatedRentalPeriod: $event })
      "
      [editSettings]="{
        min: 1,
        max: 99,
      }"
    ></boels-quantity>

    <boels-form-errors
      [control]="$any(quoteForm.get('estimatedRentalPeriod'))"
      [hide]="!submitted"
    >
    </boels-form-errors>
  </div>

  <div class="select-container">
    <span class="label-content">
      {{ 'form.quoteForm.totalNumberOfUnitsRequired' | transloco }}
    </span>
    <ng-select
      [ngClass]="{
        isInvalid: $any(quoteForm.get('numberOfUnits')).invalid,
      }"
      formControlName="numberOfUnits"
      [searchable]="false"
      [clearable]="false"
      [items]="numberOfUnitsArr"
      bindLabel="name"
      bindValue="name"
    >
    </ng-select>
    <boels-form-errors
      [control]="$any(quoteForm.get('numberOfUnits'))"
      [hide]="!submitted"
    ></boels-form-errors>
  </div>

  <boels-text-input
    [required]="true"
    name="location"
    [label]="'form.quoteForm.projectLocation' | transloco"
    type="text"
    formControlName="projectLocation"
    [formControl]="$any(quoteForm.get('projectLocation'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  <div class="date-container">
    <boels-date-picker
      (datesSelected)="onDatesSelected($event)"
      [startDateLabel]="'form.quoteForm.desiredDeliveryDate' | transloco"
      [isSingleDateMode]="true"
      [startDate]="startDate"
      [minDate]="minDate"
      [ngClass]="{
        invalid: !quoteForm.controls['deliveryDate'].value && submitted,
      }"
    ></boels-date-picker>
    <boels-form-errors
      [control]="$any(quoteForm.get('deliveryDate'))"
      [hide]="!submitted"
    ></boels-form-errors>
  </div>

  <label>
    <boels-textarea
      [maxlength]="1000"
      [label]="'form.quoteForm.remarks' | transloco"
      [placeholder]="'form.quoteForm.remarksPlaceholder' | transloco"
      [formControl]="$any(quoteForm.get('message'))"
      class="form-control"
      formControlName="message"
      rows="4"
      cols="50"
    >
    </boels-textarea>
  </label>

  <!--    Your Details Part-->
  <h3 class="heading">{{ 'form.quoteForm.yourDetails' | transloco }}</h3>
  @if ((titles$ | async)?.titles; as titles) {
    <div class="select-container">
      <span class="label-content">
        {{ 'checkout.formBillingShipping.title.label' | transloco }}
      </span>
      <ng-select
        [ngClass]="{
          isInvalid: $any(quoteForm.get('title')).invalid,
        }"
        formControlName="title"
        placeholder="
            {{ 'form.customerContactForm.placeholder' | transloco }}
            "
        [searchable]="false"
        [clearable]="false"
        [items]="titles"
        bindLabel="name"
        bindValue="code"
      >
      </ng-select>
      <boels-form-errors
        [control]="$any(quoteForm.get('title'))"
        [hide]="!submitted"
      ></boels-form-errors>
    </div>
  }

  <boels-text-input
    [required]="true"
    name="firstName"
    [label]="'checkout.formBillingShipping.firstName.label' | transloco"
    type="text"
    formControlName="firstName"
    [formControl]="$any(quoteForm.get('firstName'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  <boels-text-input
    [required]="true"
    name="surname"
    [label]="'checkout.formBillingShipping.surname.label' | transloco"
    type="text"
    formControlName="surname"
    [formControl]="$any(quoteForm.get('surname'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  <div class="phone-container">
    <span class="label-content">
      {{ 'checkout.formBillingShipping.tel.label' | transloco }}
    </span>
    <boels-phone [phoneControl]="telephone"></boels-phone>
    <boels-form-errors
      [control]="$any(quoteForm.get('telephone'))"
      [hide]="
        !submitted &&
        (!quoteForm.get('telephone')?.value ||
          quoteForm.get('telephone')?.value?.number?.length === 0)
      "
    ></boels-form-errors>
  </div>

  <boels-text-input
    [required]="true"
    name="email"
    [label]="'form.customerContactForm.email.label' | transloco"
    type="email"
    formControlName="email"
    [formControl]="$any(quoteForm.get('email'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  <!--    Company Details Part-->
  <h3 class="heading">
    {{ 'form.quoteForm.companyDetails' | transloco }}
  </h3>
  <boels-text-input
    name="companyName"
    [required]="true"
    [label]="
      'checkout.formPersonalDetails.tradeEntities.companyName' | transloco
    "
    type="text"
    formControlName="companyName"
    [formControl]="$any(quoteForm.get('companyName'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  @if ((countries$ | async)?.countries; as countries) {
    <div class="select-container">
      <span class="label-content">
        {{ 'checkout.formBillingShipping.country.label' | transloco }}
      </span>
      <ng-select
        [ngClass]="{
          isInvalid: country.invalid,
        }"
        [searchable]="true"
        [clearable]="false"
        [items]="countries"
        bindLabel="name"
        bindValue="isocode"
        formControlName="country"
      >
      </ng-select>
      <boels-form-errors
        [control]="country"
        [hide]="!submitted"
      ></boels-form-errors>
    </div>
  }

  <boels-text-input
    name="debtorNumber"
    [label]="
      'checkout.formPersonalDetails.tradeEntities.debtorNumber' | transloco
    "
    type="text"
    formControlName="debtorNumber"
    [formControl]="$any(quoteForm.get('debtorNumber'))"
    [maxlength]="6"
    [onKeypress]="onDebtorInputKeypress"
  ></boels-text-input>

  <boels-text-input
    [required]="true"
    name="address"
    [label]="'checkout.formBillingShipping.address.label' | transloco"
    type="text"
    formControlName="address"
    [formControl]="$any(quoteForm.get('address'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  <boels-text-input
    [required]="true"
    name="postcode"
    [label]="'checkout.formBillingShipping.zipcode.label' | transloco"
    type="text"
    formControlName="postcode"
    [formControl]="$any(quoteForm.get('postcode'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  <boels-text-input
    [required]="true"
    name="city"
    [label]="'checkout.formBillingShipping.city.label' | transloco"
    type="text"
    formControlName="city"
    [formControl]="$any(quoteForm.get('city'))"
    [hideErrors]="!submitted"
    [maxlength]="80"
  ></boels-text-input>

  <p
    class="google-recaptcha-notice text-subtle-gray_1000"
    [innerHTML]="'form.googleRecaptcha.notice' | transloco"
  ></p>

  <boels-privacy-statement-link></boels-privacy-statement-link>

  <hr class="divider" />

  @if ((componentData.data$ | async)?.text; as text) {
    <p>{{ text }}</p>
  }

  <button type="submit" boelsButton [variant]="'primary-brand'" #submitButton>
    {{ 'checkout.review.placeOrder' | transloco }}
  </button>
</form>
